import { Box, Typography, useMediaQuery } from "@mui/material"
import { theme } from "../../../../utils/theme/godzilla_light";
import { EDUCATION_HUB_CONTENT_MAX_WIDTH } from "../../constants"
import { Trans, useTranslation } from "react-i18next";
import { GradientCard } from "../../components";
import HallMarkImage from '../../../../assets/images/svgs/identifyingGA/hallmark.png.svg';
import TransMsg from './transMessage';

const HallMarkDisease = () => {
    const { t } = useTranslation()
    const isMobileX = useMediaQuery(theme.breakpoints.down(700))

    const hallmarkData = {
        title: t(TransMsg.HALLMARK_TITLE),
        description: t(TransMsg.HALLMARK_DESCRIPTION),
        notes: t(TransMsg.HALLMARK_NOTES),
        imageUrl: HallMarkImage,
        imageDescription: "Image courtesy of Dr. Mohammad Rafieetary"
    }

    return (
        <Box textAlign={isMobileX ? "center" : "left"} px="31px" py={"66px"} sx={{ backgroundColor: "#fff" }}>
            <Box display={"flex"} justifyContent={"center"} alignItems={"center"} flex={1}>
                <Box display={"flex"} flexDirection={"column"} gap={"24px"} maxWidth={EDUCATION_HUB_CONTENT_MAX_WIDTH} width="100%">
                    <Box display={"flex"} gap={"24px"} flexWrap={"wrap"}>
                        <Box maxWidth={"500px"}>
                            <Typography sx={{ ...theme.typography.components.sectionTitle }}>
                                <Trans
                                    i18nKey={hallmarkData.title}
                                    components={{ br: <br /> }} />
                            </Typography>

                            <Typography sx={{ ...theme.typography.components.sectionDescription, mt: "24px" }}>
                                <Trans
                                    i18nKey={hallmarkData.description}
                                    components={{ sup: <sup /> }} />
                            </Typography>
                        </Box>
                        <Box>
                            <Box sx={{ overflow: "hidden" }}>
                                <img src={hallmarkData.imageUrl} alt="download-icon" style={{ maxWidth: "338px", maxHeight: "310px", width: "100%", height: "100%" }} />
                            </Box>
                            <Typography sx={{ ...theme.typography.montseratBodyRegular, fontSize: "11px", mt: "8px", fontStyle: "italic" }}>
                                {hallmarkData.imageDescription}
                            </Typography>
                        </Box>
                    </Box>
                    <Box maxWidth={"500px"}>
                        <GradientCard
                            cardSx={{ mt: isMobileX ? "24px" : "-64px", p: isMobileX ? "19px 48px 70px 31px" : "52px 42px 85px 42px" }}
                            contentSx={{ textAlign: "left" }}
                            content={<Trans
                                i18nKey={hallmarkData.notes}
                                components={{ sup: <sup /> }} />}
                        />
                    </Box>
                </Box>
            </Box>
        </Box>
    )
}

export default HallMarkDisease